

























































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

// Mixin
import IndoorDisplayMixin from './IndoorDisplayMixin.vue'

// Component
import BottomSheetLayout from '@/components/common/BottomSheetLayout.vue'
import RoundFilterButton from '../common/buttons/RoundFilterButton.vue'

@Component({
  components: { BottomSheetLayout, RoundFilterButton },
})
export default class IndoorDisplayMobile extends mixins(IndoorDisplayMixin) {
  isOpenBottomSheet = false
  mounted() {
    window.addEventListener('load', () => {
      setTimeout(() => {
        window.scrollTo(0, 1)
      }, 100)
    })
  }
}
